module.exports = __webpack_public_path__ + "img/domain.b574b9f2.webp";